<template>
  <button
    class="text-point-color"
    @click.stop="emits('click')"
    v-tooltip="tooltip"
  >
    {{ label }}
  </button>
</template>

<script setup lang="ts">
interface IProps {
  label: string
  tooltip?: string
}

const props = defineProps<IProps>()

const emits = defineEmits([ 'click' ])
</script>

<style scoped lang="scss">

</style>